<template>
  <div class="mt-4">
    <!-- 서버 상태 -->
    <v-card class="mx-auto" max-width="95%" elevation="2">
      <v-toolbar dark dense>
        <v-toolbar-title>서버 상태</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-chip small :color="serverStatus === 'ON' ? 'green' : 'red'" dark>
          <v-icon left x-small>{{ serverStatus === 'ON' ? 'mdi-check-circle' : 'mdi-alert-circle' }}</v-icon>
          {{ serverStatus === 'ON' ? '정상' : '점검중' }}
        </v-chip>
      </v-toolbar>
      <v-card-text class="pa-0">
        <v-container fluid class="pa-0">
          <v-row no-gutters>
            <v-col cols="12" sm="4">
              <v-card flat color="#E8F5E9" class="ma-1 pa-3">
                <div class="d-flex justify-space-between align-center">
                  <div>
                    <div class="text-caption grey--text text--darken-1">진행중인 게임</div>
                    <div class="text-h5 font-weight-bold">{{ activeGameCount }}</div>
                  </div>
                  <v-icon size="36" color="green lighten-2">mdi-gamepad-variant</v-icon>
                </div>
              </v-card>
            </v-col>
            <v-col cols="12" sm="4">
              <v-card flat color="#E3F2FD" class="ma-1 pa-3">
                <div class="d-flex justify-space-between align-center">
                  <div>
                    <div class="text-caption grey--text text--darken-1">오늘의 환전 수량</div>
                    <div class="text-h5 font-weight-bold">{{ todayExchangeCount }}</div>
                  </div>
                  <v-icon size="36" color="blue lighten-2">mdi-swap-horizontal-circle</v-icon>
                </div>
              </v-card>
            </v-col>
            <v-col cols="12" sm="4">
              <v-card flat color="#FFF3E0" class="ma-1 pa-3">
                <div class="d-flex justify-space-between align-center">
                  <div>
                    <div class="text-caption grey--text text--darken-1">오늘의 커미션</div>
                    <div class="text-h5 font-weight-bold">{{ todayCommission }}</div>
                  </div>
                  <v-icon size="36" color="orange lighten-2">mdi-currency-usd</v-icon>
                </div>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>

    <!-- Broadcast 서버 접속자 (5초 갱신) -->
    <v-card class="mx-auto mt-6" max-width="95%" elevation="2">
      <v-toolbar dark dense color="indigo darken-1">
        <v-toolbar-title>
          <v-icon left small>mdi-broadcast</v-icon>Broadcast 접속자
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-chip small outlined color="white">
          <v-icon left x-small>mdi-server-network</v-icon>
          {{ serverCount }} 서버
        </v-chip>
        <v-chip small color="white" class="ml-2 indigo--text text--darken-1">
          <v-icon left x-small color="indigo darken-1">mdi-account-multiple</v-icon>
          총 {{ totalClients }}명
        </v-chip>
      </v-toolbar>
      <v-card-text class="pa-2">
        <v-simple-table dense v-if="broadcastServers.length > 0">
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">Server ID</th>
                <th class="text-left">Host:Port</th>
                <th class="text-right">접속자</th>
                <th class="text-right">Room 수</th>
                <th class="text-left">환경</th>
                <th class="text-left">갱신 시각</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="s in broadcastServers" :key="s.server_id">
                <td class="font-weight-medium">{{ s.server_id }}</td>
                <td>{{ s.host }}:{{ s.port }}</td>
                <td class="text-right">
                  <v-chip x-small :color="(s.client_count || 0) > 0 ? 'green' : 'grey lighten-2'" :dark="(s.client_count || 0) > 0">
                    {{ s.client_count || 0 }}
                  </v-chip>
                </td>
                <td class="text-right">{{ s.room_count || 0 }}</td>
                <td><v-chip x-small outlined>{{ s.env || '-' }}</v-chip></td>
                <td class="text-caption grey--text">{{ formatTime(s.updated_at) }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
        <div v-else class="text-center pa-6">
          <v-icon size="40" color="grey lighten-1">mdi-server-off</v-icon>
          <p class="text-body-2 grey--text mt-2">살아있는 broadcast 서버가 없습니다.</p>
        </div>
      </v-card-text>
    </v-card>

    <!-- 진행중인 게임 상세 -->
    <v-card class="mx-auto mt-6" max-width="95%" elevation="2">
      <v-toolbar dark dense>
        <v-toolbar-title>진행중인 게임</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text class="pa-6 text-center">
        <v-icon size="48" color="grey lighten-1">mdi-play-circle-outline</v-icon>
        <p class="text-body-1 grey--text mt-3">진행중인 게임 정보가 없습니다.</p>
        <p class="text-caption grey--text">백엔드 API 연동 후 표시됩니다.</p>
      </v-card-text>
    </v-card>

    <div class="py-12"></div>
    <div class="py-12"></div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
export default {
  name: 'Danta_Dashboard',
  data: () => ({
    serverStatus: 'ON',
    activeGameCount: 0,
    todayExchangeCount: 0,
    todayCommission: 0,
    clientCount: 0,
    mediaCount: 0,
    userCount: 0,
    // Broadcast 서버 접속자 (5초 폴링)
    broadcastServers: [],
    serverCount: 0,
    totalClients: 0,
    totalRooms: 0,
    _broadcastTimer: null,
  }),
  created() {
    this.loadDashboard();
    this.loadBroadcastServers();
    // 5초마다 broadcast 접속자 갱신
    this._broadcastTimer = setInterval(() => this.loadBroadcastServers(), 5000);
  },
  beforeDestroy() {
    if (this._broadcastTimer) {
      clearInterval(this._broadcastTimer);
      this._broadcastTimer = null;
    }
  },
  methods: {
    ...mapActions([
      'DANTA_GET_DASHBOARD',
      'DANTA_GET_BROADCAST_SERVERS',
    ]),
    async loadDashboard() {
      try {
        const d = await this.DANTA_GET_DASHBOARD();
        this.clientCount = d.client_total || 0;
        this.mediaCount = d.media_total || 0;
        this.userCount = d.user_total || 0;
        this.activeGameCount = d.game_active || 0;
        this.todayExchangeCount = d.today_total_bets || 0;
        this.todayCommission = d.today_bet_amount || 0;
      } catch (err) { console.error('대시보드 로드 실패:', err); }
    },
    async loadBroadcastServers() {
      try {
        const d = await this.DANTA_GET_BROADCAST_SERVERS();
        this.broadcastServers = Array.isArray(d.servers) ? d.servers : [];
        this.serverCount   = d.server_count   || 0;
        this.totalClients  = d.total_clients  || 0;
        this.totalRooms    = d.total_rooms    || 0;
      } catch (err) { console.warn('broadcast 서버 조회 실패:', err?.message || err); }
    },
    formatTime(iso) {
      if (!iso) return '-';
      try {
        const d = new Date(iso);
        const hh = String(d.getHours()).padStart(2, '0');
        const mm = String(d.getMinutes()).padStart(2, '0');
        const ss = String(d.getSeconds()).padStart(2, '0');
        return `${hh}:${mm}:${ss}`;
      } catch (_) { return '-'; }
    },
  },
};
</script>
